module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ppj-spinner",
    style: ({
      width: (_vm.size + "px"),
      height: (_vm.size + "px")
    })
  }, [_c('div', {
    staticClass: "ppj-spinner-content",
    style: ({
      width: (_vm.percentage + "%"),
      height: (_vm.percentage + "%"),
      top: ((50 - 0.5 * _vm.percentage) + "%"),
      left: ((50 - 0.5 * _vm.percentage) + "%")
    })
  }, [_c('span', {
    staticClass: "ppj-text"
  }, [_vm._v(_vm._s(_vm.text))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a9eb1b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/spinner.vue
// module id = 938
// module chunks = 3